import { fromJS } from 'immutable';
import { listToMap } from 'self-service-api/core/utilities/listToMap';

const settingsAdapter = settings => fromJS(listToMap(settings.settings, 'key'));

export default settingsAdapter;